import { TFunction } from 'i18next'
import { ScoreboardCardStyle } from '../../components/scoreboard/scoreboardCard/ScoreboardCard'
import { Level } from '../../types/level'

export const getLevelStyles = (
	level: Level,
	t: TFunction<'pages_saving', undefined>
): ScoreboardCardStyle => {
	const styles = {
		gold: {
			title: t('gold'),
			iconColor: 'text-[#c1a976]',
			background:
				'bg-gradient-to-b from-[#f0e0bf] via-[#fdfaf5] to-[#e3d2ae] dark:from-[#DDC590] dark:via-[#ece2cb] dark:to-[#c1a976] border border-[#a1895cd9]',
			customColor: 'text-[#6A5E44]',
		},
		silver: {
			title: t('silver'),
			iconColor: 'text-[#c1c1c1] dark:text-[#8a8a8a]',
			background:
				'bg-gradient-to-b from-[#e0e0e0] to-[#d2d2d2] dark:from-[#c4c4c4] dark:via-[#d6d6d6] dark:to-[#a5a5a5] via-[#f5f5f5] !text-text-dark border border-[#9c9c9c]',
			customColor: 'text-[#4f4f4f]',
		},
		platinum: {
			title: t('platinum'),
			iconColor: 'text-[#a0a9b3]',
			background:
				'bg-gradient-to-b from-[#e4e8ef] via-[#f7f9fc] to-[#d0d8e2] border border-[#cdd2d9]',
			customColor: 'text-[#5a5f66]',
		},
		noLevel: {
			title: t('noLevel'),
			iconColor: 'text-text-dark dark:text-text-grey-100 border border-dashed border-[#c4c4c4]',
			background: 'bg-[#f5f5f5]',
		},
	}

	return styles[level]
}
